const mobileMenuBreakpoint = 1100;
const $win = $(window);
const $body = $('body');

const $header = $('.site-header-wrap');
const $headerMenu = $('.site-header .site-header__menu');
const $headerNav = $('.site-header .site-header__nav');

function NavigateMobileSubMenu(level, $subMenu) {
    $subMenu = $subMenu || null;
    if($subMenu) {
        $headerMenu.find('.sub-menu[data-depth=' + level + ']').removeClass('active');
        $subMenu.addClass('active');
    }
    $headerMenu.css('transform', 'translate(' + (-100 * level) + '%)');
    $headerNav.attr('data-currentlevel', level);
}

$('.site-header .sub-menu-back').click(function () {
    const level = $(this).attr('data-backlevel');
    NavigateMobileSubMenu(level);
});

$('.site-header .menu-item-has-children').each(function (){
    const $self = $(this);
    const $link = $self.find('> a');
    const $subMenu = $self.find('> .sub-menu');
    const $subMenuBack = $subMenu.find('> .sub-menu__back');

    const linkHref = $link.attr('href');

    if(linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
        const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
        $link.clone().appendTo($menuItemDuplicate);
        $subMenuBack.after($menuItemDuplicate);
    }

    $link.click(function (event) {
        console.log('CLICKED');
        if($win.width() <= mobileMenuBreakpoint) {
            console.log('HEY Prevent');
            event.preventDefault();
            NavigateMobileSubMenu($subMenu.attr('data-depth'), $subMenu);
        }
    });
});

$('.mobile-close, .mobile-menu-toggle').click(function () {
    $headerNav.toggleClass('open');
    $(this).toggleClass('is-active');
});

// Add header height as css var.
function setMenuHeightVar() {
    $body.css('--header-height', $header.height() + 'px');
}

// Do this on page load
setMenuHeightVar();

// Do this on resize
window.addEventListener('resize', event => {
    setMenuHeightVar();
});
$('.wp-block-navigation-item.has-child > button').click(function () {
  $(this).parent().toggleClass('is-open').siblings().removeClass('is-open');
  $(this).attr('style', 'background-color: transparent;');
});
$('.mobile-logo').parent().addClass('mobile-logo-link');
$('.rental').on('click', function(){
  $('html').addClass('hidden-overflow');
})


const cancelBtnHTML = `<button type="button" class="rental-form__cancel cancel">Cancel</button>`;
const $form = $('.rental-form__form .gform-footer');

$('.rental').on('click', function () {
  var $title_text = $(this).find('.rental-content__title h2').text()
  $(this).parent().siblings('.rental-form').find('.rental-form__title p strong').text($title_text);
  $(this).parent().siblings('.rental-form').find('.rental-form__form .hide-input input[type="text"]').val($(this).find('.rental-content__title h2').text());
  $(this).parent().siblings('.rental-form').addClass('show-modal');
  $('html').addClass('hidden-overflow');
});

$('.rental-form__close').on('click', function () {
  $('html').removeClass('hidden-overflow');
  $('.rental-form').removeClass('show-modal');
});
$form.append(cancelBtnHTML);
$('.rental-form__cancel').on('click', function(){
  $('html').removeClass('hidden-overflow');
  $('.rental-form').removeClass('show-modal');
});

$('.shop_attributes').append('<thead><tr><th>FEATURE</th><th>DETAILS</th></tr></thead>')

$('.af_quote_fields textarea[required="required"], .af_quote_fields input[type="text"][required="required"], .af_quote_fields input[type="email"][required="required"], .af_quote_fields select[required="required"]').siblings('label').append('<span class="required">*</span>');
$('.attribute-item').parent().css('margin-bottom', '24px');

$('.addify-quote-form').on('submit', function () {
  var $button = $(this).find('button[type="submit"]');

  // Adds the class and disables the button to prevent double submissions
  $button.addClass('loading').attr('aria-disabled', 'true');
});
// $(document.body).on('added_to_cart', function(){
//   // Trigger a click on the mini-cart block button to open the drawer
//   $('.wc-block-mini-cart__button').trigger('click');
// });
